var _toConsumableArray = require("/home/highlander/projects/token-manager/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _defineProperty = require("/home/highlander/projects/token-manager/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _assertThisInitialized = require("/home/highlander/projects/token-manager/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _classCallCheck = require("/home/highlander/projects/token-manager/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/highlander/projects/token-manager/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/highlander/projects/token-manager/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/highlander/projects/token-manager/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/highlander/projects/token-manager/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _slicedToArray = require("/home/highlander/projects/token-manager/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react"), require("prop-types"), require("redux"), require("@drizzle/store")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "redux", "@drizzle/store"], e) : "object" == typeof exports ? exports["@drizzle/react-plugin"] = e(require("react"), require("prop-types"), require("redux"), require("@drizzle/store")) : t["@drizzle/react-plugin"] = e(t.react, t["prop-types"], t.redux, t["@drizzle/store"]);
}("undefined" != typeof self ? self : this, function (t, e, n, r) {
  return function (t) {
    var e = {};
    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 14);
  }([function (e, n) {
    e.exports = t;
  }, function (t, e) {
    var n,
      r,
      o = t.exports = {};
    function i() {
      throw new Error("setTimeout has not been defined");
    }
    function s() {
      throw new Error("clearTimeout has not been defined");
    }
    function c(t) {
      if (n === setTimeout) return setTimeout(t, 0);
      if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);
      try {
        return n(t, 0);
      } catch (e) {
        try {
          return n.call(null, t, 0);
        } catch (e) {
          return n.call(this, t, 0);
        }
      }
    }
    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : i;
      } catch (t) {
        n = i;
      }
      try {
        r = "function" == typeof clearTimeout ? clearTimeout : s;
      } catch (t) {
        r = s;
      }
    }();
    var u,
      a = [],
      p = !1,
      f = -1;
    function l() {
      p && u && (p = !1, u.length ? a = u.concat(a) : f = -1, a.length && d());
    }
    function d() {
      if (!p) {
        var t = c(l);
        p = !0;
        for (var e = a.length; e;) {
          for (u = a, a = []; ++f < e;) u && u[f].run();
          f = -1, e = a.length;
        }
        u = null, p = !1, function (t) {
          if (r === clearTimeout) return clearTimeout(t);
          if ((r === s || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);
          try {
            r(t);
          } catch (e) {
            try {
              return r.call(null, t);
            } catch (e) {
              return r.call(this, t);
            }
          }
        }(t);
      }
    }
    function h(t, e) {
      this.fun = t, this.array = e;
    }
    function b() {}
    o.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
      a.push(new h(t, e)), 1 !== a.length || p || c(d);
    }, h.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = b, o.addListener = b, o.once = b, o.off = b, o.removeListener = b, o.removeAllListeners = b, o.emit = b, o.prependListener = b, o.prependOnceListener = b, o.listeners = function (t) {
      return [];
    }, o.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  }, function (t, n) {
    t.exports = e;
  }, function (t, e) {
    t.exports = function (t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(0),
      o = n.n(r),
      i = n(2),
      s = n.n(i),
      c = n(37),
      u = n(38),
      a = n(39),
      p = n(40),
      f = n.n(p),
      l = n(41),
      d = n.n(l),
      h = n(44);
    n.d(e, "Initializer", function () {
      return h.a;
    });
    var b = Object(r.createContext)(),
      y = function y() {
        return Object(r.useContext)(b);
      };
    e.useDrizzle = y;
    e.useDrizzleState = function (t, e) {
      var _y = y(),
        n = _y.drizzle,
        o = Object(r.useRef)(t);
      o.current = t;
      var i = Object(r.useRef)(e),
        _Object = Object(r.useState)(o.current(n.store.getState())),
        _Object2 = _slicedToArray(_Object, 2),
        s = _Object2[0],
        c = _Object2[1],
        u = Object(r.useRef)(s);
      if (!d()(i.current, e)) {
        i.current = e;
        var _t = o.current(n.store.getState());
        d()(u.current, _t) || (u.current = _t, c(_t));
      }
      return Object(r.useEffect)(function () {
        var t = f()(function () {
            var t = o.current(n.store.getState());
            d()(u.current, t) || (u.current = t, c(t));
          }),
          e = n.store.subscribe(t);
        return function () {
          e(), t.clear();
        };
      }, [n.store]), u.current;
    };
    var m = function m(_ref) {
      var t = _ref.children,
        e = _ref.drizzle;
      var n = Object(r.useMemo)(function () {
          return Object(c.a)(e);
        }, [e]),
        i = Object(r.useMemo)(function () {
          return Object(a.a)(e);
        }, [e]),
        s = Object(r.useMemo)(function () {
          return Object(u.a)(e);
        }, [e]);
      return o.a.createElement(b.Provider, {
        value: Object(r.useMemo)(function () {
          return {
            drizzle: e,
            useCacheCall: n,
            useCacheEvents: s,
            useCacheSend: i
          };
        }, [e, n, s, i])
      }, t);
    };
    e.DrizzleProvider = m, m.propTypes = {
      children: s.a.node.isRequired,
      drizzle: s.a.shape({}).isRequired
    };
  }, function (t, e, n) {
    "use strict";

    e.a = function (t) {
      "undefined" != typeof console && "function" == typeof console.error && console.error(t);
      try {
        throw new Error(t);
      } catch (t) {}
    };
  }, function (t, e, n) {
    "use strict";

    function r() {
      return (r = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.a = r;
  }, function (t, e, n) {
    "use strict";

    e.a = function (t, e) {
      if (null == t) return {};
      var n,
        r,
        o = {},
        i = Object.keys(t);
      for (r = 0; r < i.length; r++) n = i[r], e.indexOf(n) >= 0 || (o[n] = t[n]);
      return o;
    };
  }, function (t, e, n) {
    "use strict";

    e.a = function (t, e) {
      t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
    };
  }, function (t, e, n) {
    "use strict";

    n.d(e, "b", function () {
      return i;
    }), n.d(e, "a", function () {
      return s;
    });
    var r = n(2),
      o = n.n(r),
      i = o.a.shape({
        trySubscribe: o.a.func.isRequired,
        tryUnsubscribe: o.a.func.isRequired,
        notifyNestedSubs: o.a.func.isRequired,
        isSubscribed: o.a.func.isRequired
      }),
      s = o.a.shape({
        subscribe: o.a.func.isRequired,
        dispatch: o.a.func.isRequired,
        getState: o.a.func.isRequired
      });
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      e.a = function (e, n) {
        var c, a;
        void 0 === n && (n = {});
        var v = n,
          O = v.getDisplayName,
          g = void 0 === O ? function (t) {
            return "ConnectAdvanced(" + t + ")";
          } : O,
          S = v.methodName,
          j = void 0 === S ? "connectAdvanced" : S,
          P = v.renderCountProp,
          w = void 0 === P ? void 0 : P,
          z = v.shouldHandleStateChanges,
          C = void 0 === z || z,
          x = v.storeKey,
          E = void 0 === x ? "store" : x,
          T = v.withRef,
          D = void 0 !== T && T,
          M = Object(s.a)(v, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]),
          N = E + "Subscription",
          q = b++,
          R = ((c = {})[E] = h.a, c[N] = h.b, c),
          $ = ((a = {})[N] = h.b, a);
        return function (n) {
          p()(Object(l.isValidElementType)(n), "You must pass a component to the function returned by " + j + ". Instead received " + JSON.stringify(n));
          var s = n.displayName || n.name || "Component",
            c = g(s),
            a = Object(i.a)({}, M, {
              getDisplayName: g,
              methodName: j,
              renderCountProp: w,
              shouldHandleStateChanges: C,
              storeKey: E,
              withRef: D,
              displayName: c,
              wrappedComponentName: s,
              WrappedComponent: n
            }),
            h = function (t) {
              function s(e, n) {
                var r;
                return (r = t.call(this, e, n) || this).version = q, r.state = {}, r.renderCount = 0, r.store = e[E] || n[E], r.propsMode = Boolean(e[E]), r.setWrappedInstance = r.setWrappedInstance.bind(Object(o.a)(Object(o.a)(r))), p()(r.store, 'Could not find "' + E + '" in either the context or props of "' + c + '". Either wrap the root component in a <Provider>, or explicitly pass "' + E + '" as a prop to "' + c + '".'), r.initSelector(), r.initSubscription(), r;
              }
              Object(r.a)(s, t);
              var u = s.prototype;
              return u.getChildContext = function () {
                var t,
                  e = this.propsMode ? null : this.subscription;
                return (t = {})[N] = e || this.context[N], t;
              }, u.componentDidMount = function () {
                C && (this.subscription.trySubscribe(), this.selector.run(this.props), this.selector.shouldComponentUpdate && this.forceUpdate());
              }, u.componentWillReceiveProps = function (t) {
                this.selector.run(t);
              }, u.shouldComponentUpdate = function () {
                return this.selector.shouldComponentUpdate;
              }, u.componentWillUnmount = function () {
                this.subscription && this.subscription.tryUnsubscribe(), this.subscription = null, this.notifyNestedSubs = m, this.store = null, this.selector.run = m, this.selector.shouldComponentUpdate = !1;
              }, u.getWrappedInstance = function () {
                return p()(D, "To access the wrapped instance, you need to specify { withRef: true } in the options argument of the " + j + "() call."), this.wrappedInstance;
              }, u.setWrappedInstance = function (t) {
                this.wrappedInstance = t;
              }, u.initSelector = function () {
                var t = e(this.store.dispatch, a);
                this.selector = function (t, e) {
                  var n = {
                    run: function run(r) {
                      try {
                        var o = t(e.getState(), r);
                        (o !== n.props || n.error) && (n.shouldComponentUpdate = !0, n.props = o, n.error = null);
                      } catch (t) {
                        n.shouldComponentUpdate = !0, n.error = t;
                      }
                    }
                  };
                  return n;
                }(t, this.store), this.selector.run(this.props);
              }, u.initSubscription = function () {
                if (C) {
                  var t = (this.propsMode ? this.props : this.context)[N];
                  this.subscription = new d.a(this.store, t, this.onStateChange.bind(this)), this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
                }
              }, u.onStateChange = function () {
                this.selector.run(this.props), this.selector.shouldComponentUpdate ? (this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate, this.setState(y)) : this.notifyNestedSubs();
              }, u.notifyNestedSubsOnComponentDidUpdate = function () {
                this.componentDidUpdate = void 0, this.notifyNestedSubs();
              }, u.isSubscribed = function () {
                return Boolean(this.subscription) && this.subscription.isSubscribed();
              }, u.addExtraProps = function (t) {
                if (!(D || w || this.propsMode && this.subscription)) return t;
                var e = Object(i.a)({}, t);
                return D && (e.ref = this.setWrappedInstance), w && (e[w] = this.renderCount++), this.propsMode && this.subscription && (e[N] = this.subscription), e;
              }, u.render = function () {
                var t = this.selector;
                if (t.shouldComponentUpdate = !1, t.error) throw t.error;
                return Object(f.createElement)(n, this.addExtraProps(t.props));
              }, s;
            }(f.Component);
          return h.WrappedComponent = n, h.displayName = c, h.childContextTypes = $, h.contextTypes = R, h.propTypes = R, "production" !== t.env.NODE_ENV && (h.prototype.componentWillUpdate = function () {
            var t = this;
            if (this.version !== q) {
              this.version = q, this.initSelector();
              var e = [];
              this.subscription && (e = this.subscription.listeners.get(), this.subscription.tryUnsubscribe()), this.initSubscription(), C && (this.subscription.trySubscribe(), e.forEach(function (e) {
                return t.subscription.listeners.subscribe(e);
              }));
            }
          }), u()(h, n);
        };
      };
      var r = n(8),
        o = n(19),
        i = n(6),
        s = n(7),
        c = n(20),
        u = n.n(c),
        a = n(23),
        p = n.n(a),
        f = n(0),
        l = (n.n(f), n(11)),
        d = (n.n(l), n(24)),
        h = n(9),
        b = 0,
        y = {};
      function m() {}
    }).call(e, n(1));
  }, function (t, e, n) {
    "use strict";

    (function (e) {
      "production" === e.env.NODE_ENV ? t.exports = n(21) : t.exports = n(22);
    }).call(e, n(1));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      e.a = function (t) {
        return function (e, n) {
          var r = t(e, n);
          function o() {
            return r;
          }
          return o.dependsOnOwnProps = !1, o;
        };
      }, e.b = function (e, n) {
        return function (i, s) {
          var c = s.displayName,
            u = function u(t, e) {
              return u.dependsOnOwnProps ? u.mapToProps(t, e) : u.mapToProps(t);
            };
          return u.dependsOnOwnProps = !0, u.mapToProps = function (i, s) {
            u.mapToProps = e, u.dependsOnOwnProps = o(e);
            var a = u(i, s);
            return "function" == typeof a && (u.mapToProps = a, u.dependsOnOwnProps = o(a), a = u(i, s)), "production" !== t.env.NODE_ENV && Object(r.a)(a, c, n), a;
          }, u;
        };
      };
      var r = n(13);
      function o(t) {
        return null !== t.dependsOnOwnProps && void 0 !== t.dependsOnOwnProps ? Boolean(t.dependsOnOwnProps) : 1 !== t.length;
      }
    }).call(e, n(1));
  }, function (t, e, n) {
    "use strict";

    e.a = function (t, e, n) {
      Object(r.a)(t) || Object(o.a)(n + "() in " + e + " must return a plain object. Instead received " + t + ".");
    };
    var r = n(29),
      o = n(5);
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(15),
      o = n(34),
      i = n(36),
      s = n(4);
    n.d(e, "drizzleConnect", function () {
      return r.a;
    }), n.d(e, "DrizzleProvider", function () {
      return o.a;
    }), n.d(e, "DrizzleContext", function () {
      return i.a;
    }), n.d(e, "drizzleReactHooks", function () {
      return s;
    });
  }, function (t, e, n) {
    "use strict";

    e.a = function (t) {
      for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        e[_key - 1] = arguments[_key];
      }
      var n = Object(a.a).apply(void 0, e)(t);
      var r = function r(t, e) {
        return u.a.createElement(n, o()({}, t, {
          store: e.drizzleStore
        }));
      };
      return r.contextTypes = {
        drizzleStore: s.a.object
      }, r;
    };
    var r = n(16),
      o = n.n(r),
      i = n(2),
      s = n.n(i),
      c = n(0),
      u = n.n(c),
      a = n(17);
  }, function (t, e) {
    function n() {
      return t.exports = n = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }, n.apply(this, arguments);
    }
    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    n(18), n(10);
    var r = n(25);
    n.d(e, "a", function () {
      return r.a;
    });
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var e = n(8),
        r = n(0),
        o = (n.n(r), n(2)),
        i = n.n(o),
        s = n(9),
        c = n(5),
        u = !1;
      !function (n) {
        var o;
        void 0 === n && (n = "store");
        var a = n + "Subscription",
          p = function (t) {
            Object(e.a)(i, t);
            var o = i.prototype;
            function i(e, r) {
              var o;
              return (o = t.call(this, e, r) || this)[n] = e.store, o;
            }
            return o.getChildContext = function () {
              var t;
              return (t = {})[n] = this[n], t[a] = null, t;
            }, o.render = function () {
              return r.Children.only(this.props.children);
            }, i;
          }(r.Component);
        "production" !== t.env.NODE_ENV && (p.prototype.componentWillReceiveProps = function (t) {
          this[n] !== t.store && (u || (u = !0, Object(c.a)("<Provider> does not support changing `store` on the fly. It is most likely that you see this error because you updated to Redux 2.x and React Redux 2.x which no longer hot reload reducers automatically. See https://github.com/reduxjs/react-redux/releases/tag/v2.0.0 for the migration instructions.")));
        }), p.propTypes = {
          store: s.a.isRequired,
          children: i.a.element.isRequired
        }, p.childContextTypes = ((o = {})[n] = s.a.isRequired, o[a] = s.b, o);
      }();
    }).call(e, n(1));
  }, function (t, e, n) {
    "use strict";

    e.a = function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(11),
      o = {
        childContextTypes: !0,
        contextType: !0,
        contextTypes: !0,
        defaultProps: !0,
        displayName: !0,
        getDefaultProps: !0,
        getDerivedStateFromError: !0,
        getDerivedStateFromProps: !0,
        mixins: !0,
        propTypes: !0,
        type: !0
      },
      i = {
        name: !0,
        length: !0,
        prototype: !0,
        caller: !0,
        callee: !0,
        arguments: !0,
        arity: !0
      },
      s = {
        $$typeof: !0,
        compare: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0,
        type: !0
      },
      c = {};
    function u(t) {
      return r.isMemo(t) ? s : c[t.$$typeof] || o;
    }
    c[r.ForwardRef] = {
      $$typeof: !0,
      render: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0
    };
    var a = Object.defineProperty,
      p = Object.getOwnPropertyNames,
      f = Object.getOwnPropertySymbols,
      l = Object.getOwnPropertyDescriptor,
      d = Object.getPrototypeOf,
      h = Object.prototype;
    t.exports = function t(e, n, r) {
      if ("string" != typeof n) {
        if (h) {
          var o = d(n);
          o && o !== h && t(e, o, r);
        }
        var s = p(n);
        f && (s = s.concat(f(n)));
        for (var c = u(e), b = u(n), y = 0; y < s.length; ++y) {
          var m = s[y];
          if (!(i[m] || r && r[m] || b && b[m] || c && c[m])) {
            var v = l(n, m);
            try {
              a(e, m, v);
            } catch (t) {}
          }
        }
        return e;
      }
      return e;
    };
  }, function (t, e, n) {
    "use strict";

    /** @license React v16.8.6
     * react-is.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = "function" == typeof Symbol && Symbol.for,
      o = r ? Symbol.for("react.element") : 60103,
      i = r ? Symbol.for("react.portal") : 60106,
      s = r ? Symbol.for("react.fragment") : 60107,
      c = r ? Symbol.for("react.strict_mode") : 60108,
      u = r ? Symbol.for("react.profiler") : 60114,
      a = r ? Symbol.for("react.provider") : 60109,
      p = r ? Symbol.for("react.context") : 60110,
      f = r ? Symbol.for("react.async_mode") : 60111,
      l = r ? Symbol.for("react.concurrent_mode") : 60111,
      d = r ? Symbol.for("react.forward_ref") : 60112,
      h = r ? Symbol.for("react.suspense") : 60113,
      b = r ? Symbol.for("react.memo") : 60115,
      y = r ? Symbol.for("react.lazy") : 60116;
    function m(t) {
      if ("object" == typeof t && null !== t) {
        var e = t.$$typeof;
        switch (e) {
          case o:
            switch (t = t.type) {
              case f:
              case l:
              case s:
              case u:
              case c:
              case h:
                return t;
              default:
                switch (t = t && t.$$typeof) {
                  case p:
                  case d:
                  case a:
                    return t;
                  default:
                    return e;
                }
            }
          case y:
          case b:
          case i:
            return e;
        }
      }
    }
    function v(t) {
      return m(t) === l;
    }
    e.typeOf = m, e.AsyncMode = f, e.ConcurrentMode = l, e.ContextConsumer = p, e.ContextProvider = a, e.Element = o, e.ForwardRef = d, e.Fragment = s, e.Lazy = y, e.Memo = b, e.Portal = i, e.Profiler = u, e.StrictMode = c, e.Suspense = h, e.isValidElementType = function (t) {
      return "string" == typeof t || "function" == typeof t || t === s || t === l || t === u || t === c || t === h || "object" == typeof t && null !== t && (t.$$typeof === y || t.$$typeof === b || t.$$typeof === a || t.$$typeof === p || t.$$typeof === d);
    }, e.isAsyncMode = function (t) {
      return v(t) || m(t) === f;
    }, e.isConcurrentMode = v, e.isContextConsumer = function (t) {
      return m(t) === p;
    }, e.isContextProvider = function (t) {
      return m(t) === a;
    }, e.isElement = function (t) {
      return "object" == typeof t && null !== t && t.$$typeof === o;
    }, e.isForwardRef = function (t) {
      return m(t) === d;
    }, e.isFragment = function (t) {
      return m(t) === s;
    }, e.isLazy = function (t) {
      return m(t) === y;
    }, e.isMemo = function (t) {
      return m(t) === b;
    }, e.isPortal = function (t) {
      return m(t) === i;
    }, e.isProfiler = function (t) {
      return m(t) === u;
    }, e.isStrictMode = function (t) {
      return m(t) === c;
    }, e.isSuspense = function (t) {
      return m(t) === h;
    };
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      /** @license React v16.8.6
       * react-is.development.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      "production" !== t.env.NODE_ENV && function () {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var t = "function" == typeof Symbol && Symbol.for,
          n = t ? Symbol.for("react.element") : 60103,
          r = t ? Symbol.for("react.portal") : 60106,
          o = t ? Symbol.for("react.fragment") : 60107,
          i = t ? Symbol.for("react.strict_mode") : 60108,
          s = t ? Symbol.for("react.profiler") : 60114,
          c = t ? Symbol.for("react.provider") : 60109,
          u = t ? Symbol.for("react.context") : 60110,
          a = t ? Symbol.for("react.async_mode") : 60111,
          p = t ? Symbol.for("react.concurrent_mode") : 60111,
          f = t ? Symbol.for("react.forward_ref") : 60112,
          l = t ? Symbol.for("react.suspense") : 60113,
          d = t ? Symbol.for("react.memo") : 60115,
          h = t ? Symbol.for("react.lazy") : 60116;
        var b = function b(t, e) {
          if (void 0 === e) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");
          if (!t) {
            for (var n = arguments.length, r = Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) r[o - 2] = arguments[o];
            (function (t) {
              for (var e = arguments.length, n = Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
              var o = 0,
                i = "Warning: " + t.replace(/%s/g, function () {
                  return n[o++];
                });
              "undefined" != typeof console && console.warn(i);
              try {
                throw new Error(i);
              } catch (t) {}
            }).apply(void 0, [e].concat(r));
          }
        };
        function y(t) {
          if ("object" == typeof t && null !== t) {
            var e = t.$$typeof;
            switch (e) {
              case n:
                var b = t.type;
                switch (b) {
                  case a:
                  case p:
                  case o:
                  case s:
                  case i:
                  case l:
                    return b;
                  default:
                    var y = b && b.$$typeof;
                    switch (y) {
                      case u:
                      case f:
                      case c:
                        return y;
                      default:
                        return e;
                    }
                }
              case h:
              case d:
              case r:
                return e;
            }
          }
        }
        var m = a,
          v = p,
          O = u,
          g = c,
          S = n,
          j = f,
          P = o,
          w = h,
          z = d,
          C = r,
          x = s,
          E = i,
          T = l,
          D = !1;
        function M(t) {
          return y(t) === p;
        }
        e.typeOf = y, e.AsyncMode = m, e.ConcurrentMode = v, e.ContextConsumer = O, e.ContextProvider = g, e.Element = S, e.ForwardRef = j, e.Fragment = P, e.Lazy = w, e.Memo = z, e.Portal = C, e.Profiler = x, e.StrictMode = E, e.Suspense = T, e.isValidElementType = function (t) {
          return "string" == typeof t || "function" == typeof t || t === o || t === p || t === s || t === i || t === l || "object" == typeof t && null !== t && (t.$$typeof === h || t.$$typeof === d || t.$$typeof === c || t.$$typeof === u || t.$$typeof === f);
        }, e.isAsyncMode = function (t) {
          return D || (D = !0, b(!1, "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), M(t) || y(t) === a;
        }, e.isConcurrentMode = M, e.isContextConsumer = function (t) {
          return y(t) === u;
        }, e.isContextProvider = function (t) {
          return y(t) === c;
        }, e.isElement = function (t) {
          return "object" == typeof t && null !== t && t.$$typeof === n;
        }, e.isForwardRef = function (t) {
          return y(t) === f;
        }, e.isFragment = function (t) {
          return y(t) === o;
        }, e.isLazy = function (t) {
          return y(t) === h;
        }, e.isMemo = function (t) {
          return y(t) === d;
        }, e.isPortal = function (t) {
          return y(t) === r;
        }, e.isProfiler = function (t) {
          return y(t) === s;
        }, e.isStrictMode = function (t) {
          return y(t) === i;
        }, e.isSuspense = function (t) {
          return y(t) === l;
        };
      }();
    }).call(e, n(1));
  }, function (t, e, n) {
    "use strict";

    (function (e) {
      t.exports = function (t, n, r, o, i, s, c, u) {
        if ("production" !== e.env.NODE_ENV && void 0 === n) throw new Error("invariant requires an error message argument");
        if (!t) {
          var a;
          if (void 0 === n) a = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
            var p = [r, o, i, s, c, u],
              f = 0;
            (a = new Error(n.replace(/%s/g, function () {
              return p[f++];
            }))).name = "Invariant Violation";
          }
          throw a.framesToPop = 1, a;
        }
      };
    }).call(e, n(1));
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return i;
    });
    var r = null,
      o = {
        notify: function notify() {}
      };
    var i = function () {
      function t(t, e, n) {
        this.store = t, this.parentSub = e, this.onStateChange = n, this.unsubscribe = null, this.listeners = o;
      }
      var e = t.prototype;
      return e.addNestedSub = function (t) {
        return this.trySubscribe(), this.listeners.subscribe(t);
      }, e.notifyNestedSubs = function () {
        this.listeners.notify();
      }, e.isSubscribed = function () {
        return Boolean(this.unsubscribe);
      }, e.trySubscribe = function () {
        this.unsubscribe || (this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange), this.listeners = function () {
          var t = [],
            e = [];
          return {
            clear: function clear() {
              e = r, t = r;
            },
            notify: function notify() {
              for (var n = t = e, r = 0; r < n.length; r++) n[r]();
            },
            get: function get() {
              return e;
            },
            subscribe: function subscribe(n) {
              var o = !0;
              return e === t && (e = t.slice()), e.push(n), function () {
                o && t !== r && (o = !1, e === t && (e = t.slice()), e.splice(e.indexOf(n), 1));
              };
            }
          };
        }());
      }, e.tryUnsubscribe = function () {
        this.unsubscribe && (this.unsubscribe(), this.unsubscribe = null, this.listeners.clear(), this.listeners = o);
      }, t;
    }();
  }, function (t, e, n) {
    "use strict";

    var r = n(6),
      o = n(7),
      i = n(10),
      s = n(26),
      c = n(27),
      u = n(30),
      a = n(31),
      p = n(32);
    function f(t, e, n) {
      for (var r = e.length - 1; r >= 0; r--) {
        var o = e[r](t);
        if (o) return o;
      }
      return function (e, r) {
        throw new Error("Invalid value of type " + typeof t + " for " + n + " argument when connecting component " + r.wrappedComponentName + ".");
      };
    }
    function l(t, e) {
      return t === e;
    }
    e.a = function (t) {
      var e = void 0 === t ? {} : t,
        n = e.connectHOC,
        d = void 0 === n ? i.a : n,
        h = e.mapStateToPropsFactories,
        b = void 0 === h ? u.a : h,
        y = e.mapDispatchToPropsFactories,
        m = void 0 === y ? c.a : y,
        v = e.mergePropsFactories,
        O = void 0 === v ? a.a : v,
        g = e.selectorFactory,
        S = void 0 === g ? p.a : g;
      return function (t, e, n, i) {
        void 0 === i && (i = {});
        var c = i,
          u = c.pure,
          a = void 0 === u || u,
          p = c.areStatesEqual,
          h = void 0 === p ? l : p,
          y = c.areOwnPropsEqual,
          v = void 0 === y ? s.a : y,
          g = c.areStatePropsEqual,
          j = void 0 === g ? s.a : g,
          P = c.areMergedPropsEqual,
          w = void 0 === P ? s.a : P,
          z = Object(o.a)(c, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]),
          C = f(t, b, "mapStateToProps"),
          x = f(e, m, "mapDispatchToProps"),
          E = f(n, O, "mergeProps");
        return d(S, Object(r.a)({
          methodName: "connect",
          getDisplayName: function getDisplayName(t) {
            return "Connect(" + t + ")";
          },
          shouldHandleStateChanges: Boolean(t),
          initMapStateToProps: C,
          initMapDispatchToProps: x,
          initMergeProps: E,
          pure: a,
          areStatesEqual: h,
          areOwnPropsEqual: v,
          areStatePropsEqual: j,
          areMergedPropsEqual: w
        }, z));
      };
    }();
  }, function (t, e, n) {
    "use strict";

    e.a = function (t, e) {
      if (o(t, e)) return !0;
      if ("object" != typeof t || null === t || "object" != typeof e || null === e) return !1;
      var n = Object.keys(t),
        i = Object.keys(e);
      if (n.length !== i.length) return !1;
      for (var s = 0; s < n.length; s++) if (!r.call(e, n[s]) || !o(t[n[s]], e[n[s]])) return !1;
      return !0;
    };
    var r = Object.prototype.hasOwnProperty;
    function o(t, e) {
      return t === e ? 0 !== t || 0 !== e || 1 / t == 1 / e : t != t && e != e;
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(28),
      o = (n.n(r), n(12));
    e.a = [function (t) {
      return "function" == typeof t ? Object(o.b)(t, "mapDispatchToProps") : void 0;
    }, function (t) {
      return t ? void 0 : Object(o.a)(function (t) {
        return {
          dispatch: t
        };
      });
    }, function (t) {
      return t && "object" == typeof t ? Object(o.a)(function (e) {
        return Object(r.bindActionCreators)(t, e);
      }) : void 0;
    }];
  }, function (t, e) {
    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    e.a = function (t) {
      if ("object" != typeof t || null === t) return !1;
      var e = Object.getPrototypeOf(t);
      if (null === e) return !0;
      var n = e;
      for (; null !== Object.getPrototypeOf(n);) n = Object.getPrototypeOf(n);
      return e === n;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(12);
    e.a = [function (t) {
      return "function" == typeof t ? Object(r.b)(t, "mapStateToProps") : void 0;
    }, function (t) {
      return t ? void 0 : Object(r.a)(function () {
        return {};
      });
    }];
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var r = n(6),
        o = n(13);
      function i(t, e, n) {
        return Object(r.a)({}, n, t, e);
      }
      e.a = [function (e) {
        return "function" == typeof e ? function (e) {
          return function (n, r) {
            var i,
              s = r.displayName,
              c = r.pure,
              u = r.areMergedPropsEqual,
              a = !1;
            return function (n, r, p) {
              var f = e(n, r, p);
              return a ? c && u(f, i) || (i = f) : (a = !0, i = f, "production" !== t.env.NODE_ENV && Object(o.a)(i, s, "mergeProps")), i;
            };
          };
        }(e) : void 0;
      }, function (t) {
        return t ? void 0 : function () {
          return i;
        };
      }];
    }).call(e, n(1));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      e.a = function (e, n) {
        var c = n.initMapStateToProps,
          u = n.initMapDispatchToProps,
          a = n.initMergeProps,
          p = Object(r.a)(n, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]),
          f = c(e, p),
          l = u(e, p),
          d = a(e, p);
        "production" !== t.env.NODE_ENV && Object(o.a)(f, l, d, p.displayName);
        return (p.pure ? s : i)(f, l, d, e, p);
      };
      var r = n(7),
        o = n(33);
      function i(t, e, n, r) {
        return function (o, i) {
          return n(t(o, i), e(r, i), i);
        };
      }
      function s(t, e, n, r, o) {
        var i,
          s,
          c,
          u,
          a,
          p = o.areStatesEqual,
          f = o.areOwnPropsEqual,
          l = o.areStatePropsEqual,
          d = !1;
        function h(o, d) {
          var h = !f(d, s),
            b = !p(o, i);
          return i = o, s = d, h && b ? (c = t(i, s), e.dependsOnOwnProps && (u = e(r, s)), a = n(c, u, s)) : h ? (t.dependsOnOwnProps && (c = t(i, s)), e.dependsOnOwnProps && (u = e(r, s)), a = n(c, u, s)) : b ? function () {
            var e = t(i, s),
              r = !l(e, c);
            return c = e, r && (a = n(c, u, s)), a;
          }() : a;
        }
        return function (o, p) {
          return d ? h(o, p) : function (o, p) {
            return c = t(i = o, s = p), u = e(r, s), a = n(c, u, s), d = !0, a;
          }(o, p);
        };
      }
    }).call(e, n(1));
  }, function (t, e, n) {
    "use strict";

    e.a = function (t, e, n, r) {
      o(t, "mapStateToProps", r), o(e, "mapDispatchToProps", r), o(n, "mergeProps", r);
    };
    var r = n(5);
    function o(t, e, n) {
      if (!t) throw new Error("Unexpected value for " + e + " in " + n + ".");
      "mapStateToProps" !== e && "mapDispatchToProps" !== e || t.hasOwnProperty("dependsOnOwnProps") || Object(r.a)("The selector for " + e + " of " + n + " did not specify a value for dependsOnOwnProps.");
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(3),
      o = n.n(r),
      i = n(0),
      s = (n.n(i), n(2)),
      c = n.n(s),
      u = n(35);
    n.n(u);
    var a = /*#__PURE__*/function (_i$Component) {
      _inherits(a, _i$Component);
      function a(t, e) {
        _classCallCheck(this, a);
        return _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, t, e));
      }
      _createClass(a, [{
        key: "getChildContext",
        value: function getChildContext() {
          var t = this.props.store ? this.props.store : Object(u.generateStore)(this.props.options);
          return {
            drizzle: new u.Drizzle(this.props.options, t),
            drizzleStore: t
          };
        }
      }, {
        key: "render",
        value: function render() {
          return i.Children.only(this.props.children);
        }
      }]);
      return a;
    }(i.Component);
    o()(a, "propTypes", {
      options: c.a.object.isRequired,
      store: c.a.object
    }), o()(a, "childContextTypes", {
      drizzle: c.a.object.isRequired,
      drizzleStore: c.a.object.isRequired
    }), e.a = a;
  }, function (t, e) {
    t.exports = r;
  }, function (t, e, n) {
    "use strict";

    var r = n(3),
      o = n.n(r),
      i = n(0),
      s = n.n(i);
    var c = s.a.createContext();
    e.a = {
      Context: c,
      Consumer: c.Consumer,
      Provider: /*#__PURE__*/function (_s$a$Component) {
        _inherits(Provider, _s$a$Component);
        function Provider() {
          var _getPrototypeOf2;
          var _this;
          _classCallCheck(this, Provider);
          for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            t[_key2] = arguments[_key2];
          }
          _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Provider)).call.apply(_getPrototypeOf2, [this].concat(t))), o()(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
            drizzleState: null,
            initialized: !1
          });
          return _this;
        }
        _createClass(Provider, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            var t = this;
            var e = this.props.drizzle;
            this.unsubscribe = e.store.subscribe(function () {
              var n = e.store.getState();
              n.drizzleStatus.initialized && t.setState({
                drizzleState: n,
                initialized: !0
              });
            });
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.unsubscribe();
          }
        }, {
          key: "render",
          value: function render() {
            return s.a.createElement(c.Provider, {
              value: {
                drizzle: this.props.drizzle,
                drizzleState: this.state.drizzleState,
                initialized: this.state.initialized
              }
            }, this.props.children);
          }
        }]);
        return Provider;
      }(s.a.Component)
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(3),
      o = n.n(r),
      i = n(4);
    function s(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    e.a = function (t) {
      return function (e, n) {
        for (var _len3 = arguments.length, r = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          r[_key3 - 2] = arguments[_key3];
        }
        var c = "function" == typeof n,
          u = Object(i.useDrizzleState)(function (i) {
            if (c) return e.reduce(function (t, e) {
              return function (t) {
                for (var e = 1; e < arguments.length; e++) {
                  var n = null != arguments[e] ? arguments[e] : {};
                  e % 2 ? s(n, !0).forEach(function (e) {
                    o()(t, e, n[e]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : s(n).forEach(function (e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                  });
                }
                return t;
              }({}, t, _defineProperty({}, e, i.contracts[e]));
            }, {});
            {
              var _t$contracts$e$method;
              var _o = (_t$contracts$e$method = t.contracts[e].methods[n]).cacheCall.apply(_t$contracts$e$method, r),
                _s = i.contracts[e][n][_o];
              return {
                value: _s && _s.value
              };
            }
          }, r);
        return c ? n(function (e, n) {
          var _t$contracts$e$method2;
          for (var _len4 = arguments.length, r = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
            r[_key4 - 2] = arguments[_key4];
          }
          var o = (_t$contracts$e$method2 = t.contracts[e].methods[n]).cacheCall.apply(_t$contracts$e$method2, r),
            i = u[e][n][o];
          return i && i.value;
        }) : u.value;
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(3),
      o = n.n(r),
      i = n(0);
    n.n(i);
    function s(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    e.a = function (t) {
      return function (e, n, r) {
        var _Object3 = Object(i.useState)(),
          _Object4 = _slicedToArray(_Object3, 2),
          c = _Object4[0],
          u = _Object4[1],
          a = t.contracts[e],
          p = Object(i.useMemo)(function () {
            return new t.web3.eth.Contract(a.abi, a.address);
          }, [e]);
        return Object(i.useEffect)(function () {
          var t = !0;
          p.getPastEvents(n, r).then(function (e) {
            return t && u(e);
          });
          var e = a.events[n](function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = null != arguments[e] ? arguments[e] : {};
              e % 2 ? s(n, !0).forEach(function (e) {
                o()(t, e, n[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : s(n).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
              });
            }
            return t;
          }({}, r, {
            fromBlock: "latest"
          })).on("data", function (t) {
            return u(function (e) {
              return [].concat(_toConsumableArray(e), [t]);
            });
          });
          return function () {
            e.unsubscribe(), t = !1;
          };
        }, [e, n, r]), c;
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(4),
      o = n(0);
    n.n(o);
    e.a = function (t) {
      return function (e, n) {
        var _Object5 = Object(r.useDrizzleState)(function (t) {
            return {
              transactionStack: t.transactionStack,
              transactions: t.transactions
            };
          }),
          i = _Object5.transactionStack,
          s = _Object5.transactions,
          _Object6 = Object(o.useState)([]),
          _Object7 = _slicedToArray(_Object6, 2),
          c = _Object7[0],
          u = _Object7[1],
          a = c.map(function (t) {
            return s[i[t] || "undefined"];
          }),
          p = t.contracts[e].methods[n];
        return {
          TXObjects: a,
          send: function send() {
            for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              t[_key5] = arguments[_key5];
            }
            return u(function (e) {
              return [].concat(_toConsumableArray(e), [p.cacheSend.apply(p, t)]);
            });
          },
          status: a[a.length - 1] && a[a.length - 1].status
        };
      };
    };
  }, function (t, e) {
    function n(t, e, n) {
      var r, o, i, s, c;
      function u() {
        var a = Date.now() - s;
        a < e && a >= 0 ? r = setTimeout(u, e - a) : (r = null, n || (c = t.apply(i, o), i = o = null));
      }
      null == e && (e = 100);
      var a = function a() {
        i = this, o = arguments, s = Date.now();
        var a = n && !r;
        return r || (r = setTimeout(u, e)), a && (c = t.apply(i, o), i = o = null), c;
      };
      return a.clear = function () {
        r && (clearTimeout(r), r = null);
      }, a.flush = function () {
        r && (c = t.apply(i, o), i = o = null, clearTimeout(r), r = null);
      }, a;
    }
    n.debounce = n, t.exports = n;
  }, function (t, e, n) {
    var r = Array.prototype.slice,
      o = n(42),
      i = n(43),
      s = t.exports = function (t, e, n) {
        return n || (n = {}), t === e || (t instanceof Date && e instanceof Date ? t.getTime() === e.getTime() : !t || !e || "object" != typeof t && "object" != typeof e ? n.strict ? t === e : t == e : function (t, e, n) {
          var a, p;
          if (c(t) || c(e)) return !1;
          if (t.prototype !== e.prototype) return !1;
          if (i(t)) return !!i(e) && (t = r.call(t), e = r.call(e), s(t, e, n));
          if (u(t)) {
            if (!u(e)) return !1;
            if (t.length !== e.length) return !1;
            for (a = 0; a < t.length; a++) if (t[a] !== e[a]) return !1;
            return !0;
          }
          try {
            var f = o(t),
              l = o(e);
          } catch (t) {
            return !1;
          }
          if (f.length != l.length) return !1;
          for (f.sort(), l.sort(), a = f.length - 1; a >= 0; a--) if (f[a] != l[a]) return !1;
          for (a = f.length - 1; a >= 0; a--) if (p = f[a], !s(t[p], e[p], n)) return !1;
          return typeof t == typeof e;
        }(t, e, n));
      };
    function c(t) {
      return null === t || void 0 === t;
    }
    function u(t) {
      return !(!t || "object" != typeof t || "number" != typeof t.length) && "function" == typeof t.copy && "function" == typeof t.slice && !(t.length > 0 && "number" != typeof t[0]);
    }
  }, function (t, e) {
    function n(t) {
      var e = [];
      for (var n in t) e.push(n);
      return e;
    }
    (t.exports = "function" == typeof Object.keys ? Object.keys : n).shim = n;
  }, function (t, e) {
    var n = "[object Arguments]" == function () {
      return Object.prototype.toString.call(arguments);
    }();
    function r(t) {
      return "[object Arguments]" == Object.prototype.toString.call(t);
    }
    function o(t) {
      return t && "object" == typeof t && "number" == typeof t.length && Object.prototype.hasOwnProperty.call(t, "callee") && !Object.prototype.propertyIsEnumerable.call(t, "callee") || !1;
    }
    (e = t.exports = n ? r : o).supported = r, e.unsupported = o;
  }, function (t, e, n) {
    "use strict";

    var r = n(45);
    n.d(e, "a", function () {
      return r.a;
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(2),
      o = n.n(r),
      i = n(4);
    var s = function s(_ref3) {
      var t = _ref3.children,
        e = _ref3.error,
        n = _ref3.loadingContractsAndAccounts,
        r = _ref3.loadingWeb3;
      var o = Object(i.useDrizzleState)(function (t) {
        return {
          drizzleStatusInitialized: t.drizzleStatus.initialized,
          web3Status: t.web3.status
        };
      });
      return o.drizzleStatusInitialized ? t : "initialized" === o.web3Status ? n : "failed" === o.web3Status ? e : r;
    };
    s.propTypes = {
      children: o.a.node.isRequired,
      error: o.a.node,
      loadingContractsAndAccounts: o.a.node,
      loadingWeb3: o.a.node
    }, s.defaultProps = {
      error: "Error.",
      loadingContractsAndAccounts: "Loading contracts and accounts.",
      loadingWeb3: "Loading web3."
    }, e.a = s;
  }]);
});